<template>
	<div class="service-health error">
		<p class="healthcard__text">
			<span class="service-name">{{ service.name }}:</span>
			<span class="service-status">
				<template v-if="health.be"><span class="be-error">Service error!</span></template>
				<template v-if="health.fe"><span class="fe-error">UI error!</span></template>
			</span>
		</p>
	</div>
</template>

<script>
export default {
	name: "ServiceHealth",
	props: ["service"],
	computed: {
		health: function () {
			return {
				be: this.service.be === "DOWN",
				fe: this.service.fe === "DOWN",
			};
		},
	},
};
</script>
